<template>
  <SogCard class="sog-card-without-title">
    <SogCardContent>
      <table>
        <tr>
          <td colspan="2">
            <SogDataLabel
              :value="props.item.description"
            />
          </td>
        </tr>
        <tr>
          <td>Anzahl</td>
          <td>
            <SogDataLabel
              :value="props.item.count"
            />
          </td>
        </tr>
        <tr>
          <td>
            Prämie
          </td>
          <td>
            <SogDataLabel
              :value="props.item.productGrossPrice"
              :value-type="SogDataLabelValueType.Money"
            />
          </td>
        </tr>
      </table>
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import SogCard from "@/shared/ui/SogCard.vue";
import OrderItem from "@/shared/model/orderItem";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";

interface Props {
  item:OrderItem
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  item:undefined
  }
)




</script>

<style scoped>

</style>
